import React from "react";
import ReactDOM from "react-dom";
import { Menu } from "antd";
import MenuItem from "antd/lib/menu/MenuItem";
import "antd/dist/antd.css";

import { Table1 } from "./Table";

import { Filter } from "./components/Filter";
//Variable Declarations and Initializations
var userInput = null,
    listLength = 10,
    storeNames = [],
    selectedRows = [],
    rowArray = [],
    locationData = [];

ReactDOM.render(
    <div id="parentContainer">
        <img  id = "beamLogo" src="	https://assets.website-files.com/61fd716a9eae0b0519f3a1da/61fd716a9eae0b408af3a2d6_beam..svg
"/>
        <h1 className="title">Top Shopify Stores</h1>

        <div id="sideMenu">
            <Menu className="beamInfo" mode="horizontal" theme="light" >
                <MenuItem className="mi" key="firstItem">
                    <a className="mi" href="https://apps.shopify.com/partners/beamcommerce">
                        Our Products
          </a>
                </MenuItem>
                <MenuItem className="mi" key="secondItem">
                    <a className="mi" href="https://aftersell.com/about">
                        About Us
          </a>
                </MenuItem>
                <MenuItem className="mi" key="thirdItem">
                    <a className="mi" href="https://aftersell.com/demo_page">
                        Contact Us
          </a>
                </MenuItem>
            </Menu>
        </div>
        <Table1 />

        <Filter className="shopifyData" />
    </div>,
    document.getElementById("root")
);

for (var i = 0; i < listLength; i++) {
    storeNames.push(document.getElementsByClassName("Store")[i].innerText);
    rowArray.push(document.getElementsByClassName("dataRow")[i]);
    locationData.push(document.getElementsByClassName("location")[i].innerText);
}

//Button response methods

function getDataBase() {
    return rowArray;
}
function getUserInput() {
    return userInput;
}



